import React, { useState } from "react";
import logo from "../../images/Logo.png";
import home from "../../images/home.svg";
import reports from "../../images/reports.svg";
import setting from "../../images/settings.svg";
import wheelchair from "../../images/wheelchair.svg";
import disability from "../../images/disability.svg";
import heart from "../../images/heart.svg";
import Worker from "../../images/insurance.svg";
import Accommodation from "../../images/Accommodation.svg";
import Assessment from "../../images/Assessment.svg";
import File from "../../images/file-blue.svg";
import User from "../../images/user-blue.svg";
import { Link } from "react-router-dom";
import history from "../../utilities/history";
import LanguageConfirmationModalPopup from "../../containers/Std/LanguageConfirmationModalPopup";
import { PREFERED_LANGUAGE_KEYS } from "../../App.config";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionMenuItem";

const Sidebar = (props) => {
  const [menu, setMenu] = useState(false);

  // SideBar Component
  const sidebarUserItems = [
    {
      logo: home,
      heading: "STD-Dashboard.label.Sidebar.heading.title-9",
      redirectLink: "/company",
      className: "menu-item",
    },
  ];

  const sidebarItems = [
    {
      logo: home,
      heading: "STD-Dashboard.label.Sidebar.heading.title-1",
      redirectLink: "/dashboard",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.DASHBOARD,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: Assessment,
      heading: "STD-Dashboard.label.Sidebar.heading.title-11",
      redirectLink: "/currentactivity",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.CURRENT_ACTIVITY,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: disability,
      heading: "STD-Dashboard.label.Sidebar.heading.title-10",
      redirectLink: "/applicants",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.SEARCH_BY_EMPLOYEE,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: reports,
      heading: "STD-Dashboard.label.Sidebar.heading.title-3",
      redirectLink: "/forPendingServices",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.ABSENCE_TRACKING,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: heart,
      heading: "STD-Dashboard.label.Sidebar.heading.title-4",
      redirectLink: "/std",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.STD_FORM,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: disability,
      heading: "STD-Dashboard.label.Sidebar.heading.title-5",
      redirectLink: "/forPendingServices1",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.LTD,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: Worker,
      heading: "STD-Dashboard.label.Sidebar.heading.title-6",
      redirectLink: "/air",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.AIR_FORM,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: Accommodation,
      heading: "STD-Dashboard.label.Sidebar.heading.title-7",
      redirectLink: "/accomodation",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.ACMD_FORM,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: Accommodation,
      heading: "STD-Dashboard.label.Sidebar.heading.title-18",
      redirectLink: "/ccm",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.CCM_FORM,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: Assessment,
      heading: "STD-Dashboard.label.Sidebar.heading.title-8",
      redirectLink: "/forPendingServices2",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.ASSESSMENTS,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: File,
      heading: "STD-Dashboard.label.Sidebar.heading.title-12",
      redirectLink: "/file-uploads",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.FILE_UPLOADS_PAGE,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: User,
      heading: "STD-Dashboard.label.Sidebar.heading.title-13",
      redirectLink: "/user-list",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.USERS,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: User,
      heading: "STD-Dashboard.label.Sidebar.heading.title-14",
      redirectLink: "/back-up-user",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.BACKUP_USER,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: reports,
      heading: "MyApplication.Page.Title",
      redirectLink: "/myApplications",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.MY_APPLICATIONS,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: reports,
      heading: "STD-Dashboard.label.Sidebar.heading.title-17",
      redirectLink: "/report",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.REPORT_SETTING,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: reports,
      heading: "STD-Dashboard.label.Sidebar.heading.title-16",
      redirectLink: "/myreport",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.MY_REPORT,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: setting,
      heading: "STD-Dashboard.label.Sidebar.heading.title-2",
      redirectLink: "/settings",
      className: "menu-item",
      permissionModule: PERMISSON_MODULES.SETTING_PAGE,
      permissionType: PERMISSION_TYPE.VIEW
    },
  ];

  const redirectOnMenuClick = (redirectPath) => {
    history.push(redirectPath);
  };

  const onMenuToggle = () => {
    props.onMenuToggle(!props.isSideMenuOpen);
  };

  const onLanguageSelection = (selectedLanguage) => {
    //PREFERED_LANGUAGE_KEYS.FrenchCanada
    props.languageChange(selectedLanguage);
    props.closeRemoveModal();
    history.push("/std");
  };

  const openModal = () => {
    if (
      window.location.hash !== "#/std" &&
      (props?.managersDetails?.languagePreference === null ||
        props?.managersDetails?.languagePreference === "" ||
        props?.managersDetails?.languagePreference === undefined)
    ) {
      props.openSetModalAction(
        <LanguageConfirmationModalPopup
          onLanguageSelection={onLanguageSelection}
        />
      );
    } else {
      props.languageChange(
        props?.managersDetails?.languagePreference
          ? PREFERED_LANGUAGE_KEYS.FrenchCanada
          : PREFERED_LANGUAGE_KEYS.EnglishUS
      );
      history.push("/std");
    }
  };

  const decideSidebarItems = () => {
    if (localStorage.getItem("AUTH_TOKEN") === "user@admin.com") {
      return sidebarUserItems;
    } else {
      return sidebarItems;
    }
  };

  return (
    <>
      <div className="mobi-menu">
        <ul className="Menu-nav">
          {decideSidebarItems().map((item, index) => (
            <ShowForPermission key={index} module={item.permissionModule} permission={item.permissionType}>
              <li
                key={item.heading}
                className={
                  window.location.hash === `#${item.redirectLink}`
                    ? "mobi-menu-active"
                    : ""
                }
              >
                <div
                  onClick={() => {
                    redirectOnMenuClick(item.redirectLink);
                  }}
                  className={item.className}
                >
                  <div>
                    <img src={item.logo} alt="" />
                  </div>
                  <span>{props.context.t(item.heading)}</span>
                </div>
              </li>
            </ShowForPermission>
          ))}
        </ul>
      </div>
      <div className="Left-Panel">
        <div className="Left-menu">
          <div className="logo">
            <img className="menu-text" src={logo} alt="" />
            <span className="logo-icon">
              <img className="menu-text" src={logo} alt="" />
            </span>
            <div
              className="arrow-border"
              onClick={() => {
                onMenuToggle();
              }}
            >
              <div className="arrow left"> </div>
            </div>
          </div>
          <ul className="Menu-nav">
            {decideSidebarItems().map((item, index) => (
              <ShowForPermission key={index} module={item.permissionModule} permission={item.permissionType}>
                <li
                  className={
                    window.location.hash === `#${item.redirectLink}`
                      ? "active"
                      : ""
                  }
                >
                  <div
                    onClick={() => {

                      redirectOnMenuClick(item.redirectLink);

                    }}
                    className={item.className}
                  >
                    <div>
                      <img src={item.logo} alt="" />
                    </div>
                    <span className="menu-text">
                      {props.context.t(item.heading)}
                    </span>
                  </div>
                </li>
              </ShowForPermission>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
